module.exports = __webpack_public_path__ + "static/img/newsbanner.89ac39a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news_old/newsbanner.jpg
// module id = 85l/
// module chunks = 6